<template>
  <v-dialog v-model="dialog" width="600" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
    <v-card>
      <v-card-title class="primary white--text"
        ><v-toolbar-title>THÊM KHEN THƯỞNG KỈ LUẬT</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text>
        <violation-new-form ref="form" @update:valid="isFormValid = $event" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer />
        <v-btn depressed color="primary" class="ma-2 white--text" @click="save" :disabled="!isFormValid">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ViolationNewForm from './ViolationNewForm.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    ViolationNewForm
  },
  props: {
    state: Boolean
  },
  data() {
    return {
      dialog: false,
      loading: false,
      isFormValid: false
    }
  },
  methods: {
    ...mapActions('violation', ['batchCreateViolation']),
    async save() {
      if (!this.$refs.form.validate()) return
      this.loading = true
      const dataList = this.$refs.form.getData()
      
      if (!dataList || dataList.length === 0) {
        this.loading = false
        return
      }

      const items = dataList.map(({ classData, ...data }) => ({
        ...data,
        class: classData
      }))

      const success = await this.batchCreateViolation(items)
      if (success) {
        this.$alert.success('Tạo mới thành công')
        this.$emit('done')
        this.$refs.form.resetDefault()
        this.dialog = false
      }
      this.loading = false
    },
    cancel() {
      this.dialog = false
      this.$refs.form.reset()
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>
